module.exports = __webpack_public_path__ + "img/downArrow.eddfa7c9.svg";